import { UpdatableForm } from '../../../../components/Purchasing/SupplierRegistration/Form/Member'
import React, { Component } from 'react'
import { Form, Col, Divider, Input, Row } from 'antd'

function RepresentativeContact(props) {
  const { getFieldDecorator, setFieldsValue } = props.form
  const { supplierRegistration, rep, accountsRep, logisticsRep, path } = props

  const useData = path === 'representativeContact' ? rep : path === 'accounts' ? accountsRep : logisticsRep

  return (
    <Form className="steps-content">
      <Divider orientation="left">Representative Contact Details</Divider>
      <Row>
        <Col span={12}>
          <UpdatableForm
            {...{
              setFieldsValue,
              getFieldDecorator,
              label: 'Name',
              path: `${path}.name`,
              oldPath: `fn`,
              newData: supplierRegistration,
              newPath: `${path}.name`,
              oldData: useData,
            }}
          />
        </Col>
        <Col span={12}>
          <UpdatableForm
            {...{
              setFieldsValue,
              getFieldDecorator,
              label: 'Position',
              path: `${path}.position`,
              oldPath: `position`,
              newData: supplierRegistration,
              newPath: `${path}.position`,
              oldData: useData,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <UpdatableForm
            {...{
              setFieldsValue,
              getFieldDecorator,
              label: 'Telephone Number',
              path: `${path}.telephoneNo`,
              oldPath: `phone.label`,
              newData: supplierRegistration,
              newPath: `${path}.telephoneNo`,
              oldData: useData,
              required: false,
            }}
          />
        </Col>
        <Col span={12}>
          <UpdatableForm
            {...{
              setFieldsValue,
              getFieldDecorator,
              label: 'Mobile Number',
              path: `${path}.mobileNo`,
              oldPath: `mobile.label`,
              newData: supplierRegistration,
              newPath: `${path}.mobileNo`,
              oldData: rep,
              required: false,
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <UpdatableForm
            {...{
              setFieldsValue,
              getFieldDecorator,
              label: 'Email',
              path: `${path}.email`,
              oldPath: `email.label`,
              newData: supplierRegistration,
              newPath: `${path}.email`,
              oldData: rep,
            }}
          />
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(RepresentativeContact)
